import React from 'react';
import './SkeletonHeader.css';
import {Skeleton} from 'antd';

export function SkeletonCard() {
    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#fff', gap: 24, padding: 8 }}>
        {/* Barra vertical izquierda */}
        <div style={{ width: 24, marginRight: 16, display: 'flex', flexDirection: 'column' }}>
          <Skeleton.Button active style={{ width: 24, height: '100vh', borderRadius: 4,  }} />
        </div>
        {/* Contenido principal */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 24, padding: 24 }}>
          {/* Barra horizontal superior */}
          <Skeleton.Button active style={{ width: '100%', height: 750, borderRadius: 8 }} block />
        </div>
      </div>
    )
}